<template>
	<div class="certificate-card">
		<h3 class="certificate-card--title">PPE Equipment</h3>

		<div class="flex-table">
			<list-item
				v-for="(item, index) in listOfItems"
				:key="item.id || index"
				:active="false"
			>
				<template slot="title">
					<div>
						<h5 class="text-primary">{{item.name}}</h5>
						<h6>{{getLastSubmissionText(item.last_submission)}}</h6>
					</div>
				</template>

				<template slot="center">
					<div class="badge badge--sm badge--primary">{{item.count}}</div>
				</template>
			</list-item>

			<div v-if="!ppe_registers.length" class="flex-table--row">
				<div class="flex-table--cell flex-table--cell-grow-always">
					<h6>No PPE Submitted</h6>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import moment from 'moment';

export default {
    name: "PpeEquipmentCard",
    props: {
        ppe_registers: {
            required: true
        }
    },

    methods: {
        getLastSubmissionText(submission) {
            const submitted_at = submission.submitted_formatted_3;
            const submitted_time = moment(submission.submitted_at_fix).format('HH:mm');

            const job = submission.instance.job.name;

            return `Last submitted ${submitted_at} on ${job} at ${submitted_time}`;
        }
    },

    computed: {
        listOfItems(){
            let items = {};

            this.ppe_registers.forEach(register => {
                if (!items[register.item.id])
                    items[register.item.id] = {
                        name: register.item.name,
                        count: 0,
                        last_submission: null
                    };

                let item = items[register.item.id];

                if (!item.last_submission || Date.parse(register.form_submission.submitted_at) > Date.parse(item.last_submission.submitted_at))
                    item.last_submission = register.form_submission;

                item.count += register.count;
            });

            return Object.values(items);
        }
    }
}
</script>
